import { render } from "./VTBPayButton.vue?vue&type=template&id=70eb7502&ts=true"
import script from "./VTBPayButton.vue?vue&type=script&lang=ts"
export * from "./VTBPayButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__